import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-rooms-page',
    templateUrl: './rooms-page.component.html',
    styleUrls: ['./rooms-page.component.scss']
})
export class RoomsPageComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

}